<div class="page-layout blank py-8 px-24" fusePerfectScrollbar>
  <div class="message-box warning py-4 mb-24">
    You are generating Reverse Order for AWB: {{ awbNumber }}
  </div>

  <!-- Reverse QC Checkbox -->
  <div class="mb-24">
    <mat-checkbox
      [checked]="reverseQCEnabled"
      (change)="onReverseQCCheckboxChange($event)"
      color="primary"
    >
      <strong>Enable Reverse QC</strong>
    </mat-checkbox>
    <p class="text-muted mt-4">
      Enable quality check for reverse orders with detailed product information
    </p>

    <!-- QC Configuration Fields -->
    <div *ngIf="reverseQCEnabled && reverseQCForm" [formGroup]="reverseQCForm" class="mt-16">
      <div
        fxLayout="row"
        fxLayout.lt-sm="column"
        fxLayoutGap="0px"
        fxLayoutGap.gt-xs="20px"
      >
        <mat-form-field appearance="outline" fxFlex>
          <mat-label>Return Reason</mat-label>
          <input
            matInput
            placeholder="e.g., Wrong size delivered"
            formControlName="return_reason"
            maxlength="200"
            trimValue
          />
        </mat-form-field>

        <mat-form-field appearance="outline" fxFlex>
          <mat-label>RVP Type</mat-label>
          <mat-select formControlName="rvp_type">
            <mat-option value="open_box">Open Box</mat-option>
            <mat-option value="sealed_box">Sealed Box</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>

  <div fxLayout="column" fxLayoutAlign="start stretch" class="formArrayClass">
    <ng-container
      *ngFor="
        let groupControls of itemDetailsForm?.controls;
        let i = index;
        first as First
      "
    >
      <div
        fxLayout="column"
        [formGroup]="groupControls"
        class="form-array-border"
      >
        <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-12">
          <h3 class="font-weight-600 m-0 ml-4">Item #{{ i + 1 }}</h3>

          <div fxLayout="row">
            <button
              type="button"
              mat-icon-button
              aria-label="Remove Item"
              (click)="removeItemEvent.emit(i)"
              color="warn"
              title="Remove Item"
              [disabled]="!(itemDetailsForm.value.length > 1)"
            >
              <mat-icon>remove_circle_outline</mat-icon>
            </button>
          </div>
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-sm="column"
          fxLayoutGap="0px"
          fxLayoutGap.gt-xs="20px"
        >
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Item Name</mat-label>
            <input
              matInput
              placeholder="Item Name"
              [formControl]="groupControls?.controls?.name"
              maxlength="100"
              required
              trimValue
            />

            <mat-error>
              <error-message
                fieldName="Item Name"
                [formControlErr]="groupControls?.controls?.name"
              ></error-message>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex>
            <mat-label>SKU</mat-label>
            <input
              matInput
              placeholder="SKU"
              [formControl]="groupControls?.controls?.sku"
              maxlength="50"
              trimValue
            />

            <mat-error>
              <error-message
                fieldName="SKU"
                [formControlErr]="groupControls?.controls?.sku"
              ></error-message>
            </mat-error>
          </mat-form-field>
        </div>

        <div
          fxLayout="row"
          fxLayout.lt-sm="column"
          fxLayoutGap="0px"
          fxLayoutGap.gt-xs="20px"
        >
          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Value</mat-label>
            <input
              matInput
              placeholder="Value"
              [formControl]="groupControls?.controls?.price"
              maxlength="20"
              decimals
              required
            />

            <mat-error>
              <error-message
                fieldName="Value"
                [formControlErr]="groupControls?.controls?.price"
                patternMsg="Only positive numbers upto 2 decimal digits."
              ></error-message>
            </mat-error>
          </mat-form-field>

          <mat-form-field appearance="outline" fxFlex>
            <mat-label>Quantity</mat-label>
            <input
              matInput
              placeholder="Quantity"
              [formControl]="groupControls?.controls?.quantity"
              maxlength="10"
              digits
              required
            />

            <mat-error>
              <error-message
                fieldName="Quantity"
                [formControlErr]="groupControls?.controls?.quantity"
                patternMsg="Only positive numbers."
              ></error-message>
            </mat-error>
          </mat-form-field>
        </div>

        <!-- Reverse QC Fields -->
        <ng-container *ngIf="reverseQCEnabled">
          <h4 class="font-weight-600 mt-16 mb-8 accent-fg">
            Quality Check Information
          </h4>

          <div
            fxLayout="row"
            fxLayout.lt-sm="column"
            fxLayoutGap="0px"
            fxLayoutGap.gt-xs="20px"
          >
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Product Name</mat-label>
              <input
                matInput
                placeholder="Product Name"
                [formControl]="groupControls?.controls?.product_name"
                readonly
              />
              <mat-hint>Synced from Item Name</mat-hint>
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Brand</mat-label>
              <input
                matInput
                placeholder="Brand"
                [formControl]="groupControls?.controls?.brand"
                maxlength="50"
                trimValue
              />
            </mat-form-field>
          </div>

          <div
            fxLayout="row"
            fxLayout.lt-sm="column"
            fxLayoutGap="0px"
            fxLayoutGap.gt-xs="20px"
          >
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Size</mat-label>
              <input
                matInput
                placeholder="Size"
                [formControl]="groupControls?.controls?.size"
                maxlength="20"
                trimValue
              />
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Color</mat-label>
              <input
                matInput
                placeholder="Color"
                [formControl]="groupControls?.controls?.color"
                maxlength="30"
                trimValue
              />
            </mat-form-field>
          </div>

          <div
            fxLayout="row"
            fxLayout.lt-sm="column"
            fxLayoutGap="0px"
            fxLayoutGap.gt-xs="20px"
          >
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>IMEI</mat-label>
              <input
                matInput
                placeholder="IMEI"
                [formControl]="groupControls?.controls?.imei"
                maxlength="50"
                trimValue
              />
            </mat-form-field>

            <mat-form-field appearance="outline" fxFlex>
              <mat-label>Serial Number</mat-label>
              <input
                matInput
                placeholder="Serial Number"
                [formControl]="groupControls?.controls?.serial_no"
                maxlength="50"
                trimValue
              />
            </mat-form-field>
          </div>

          <div
            fxLayout="row"
            fxLayout.lt-sm="column"
            fxLayoutGap="0px"
            fxLayoutGap.gt-xs="20px"
          >
            <mat-form-field appearance="outline" fxFlex>
              <mat-label>EAN Barcode</mat-label>
              <input
                matInput
                placeholder="EAN Barcode"
                [formControl]="groupControls?.controls?.ean_barcode"
                maxlength="50"
                trimValue
              />
            </mat-form-field>
          </div>

          <!-- Product Images Section -->
          <div class="mt-16">
            <div fxLayout="row" fxLayoutAlign="space-between center" class="mb-8">
              <h5 class="font-weight-600 m-0">Product Images</h5>
              <span class="text-muted" style="font-size: 12px;">
                <span [ngClass]="{'text-success': getProductImages(i).length >= 1, 'text-warn': getProductImages(i).length === 0}">
                  {{ getProductImages(i).length }}
                </span>
                / min 1 required
              </span>
            </div>

            <!-- Image Upload Button -->
            <div
              fxLayout="row"
              fxLayout.lt-sm="column"
              fxLayoutGap="10px"
              class="mb-12"
            >
              <input
                type="file"
                hidden
                #fileInput
                accept="image/png,image/jpeg,image/jpg"
                (change)="onFileSelected($event, i)"
              />
              <button
                type="button"
                mat-stroked-button
                color="primary"
                (click)="fileInput.click()"
              >
                <mat-icon>cloud_upload</mat-icon>
                Upload Image
              </button>

              <mat-form-field appearance="outline" fxFlex>
                <mat-label>Or paste image URL</mat-label>
                <input
                  matInput
                  placeholder="https://example.com/image.jpg"
                  #imageUrlInput
                  trimValue
                />
              </mat-form-field>
              <button
                type="button"
                mat-flat-button
                color="primary"
                (click)="onAddImageUrl(i, imageUrlInput)"
              >
                Add URL
              </button>
            </div>

            <!-- Display current images -->
            <div
              *ngIf="getProductImages(i).length > 0"
              class="images-list"
              fxLayout="row wrap"
              fxLayoutGap="10px"
            >
              <div
                *ngFor="
                  let imageControl of getProductImages(i).controls;
                  let imgIndex = index
                "
                class="image-item"
                fxLayout="column"
                fxLayoutAlign="start center"
              >
                <div class="image-preview">
                  <img
                    [src]="imageControl.value"
                    alt="Product image {{ imgIndex + 1 }}"
                    style="max-width: 100px; max-height: 100px; min-width: 100px; min-height: 100px;"
                    (error)="onImageError($event)"
                  />
                </div>
                <button
                  type="button"
                  mat-icon-button
                  color="warn"
                  (click)="onRemoveImage(i, imgIndex)"
                  title="Remove Image"
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <p class="text-muted mt-4" *ngIf="getProductImages(i).length === 0">
              <mat-icon class="mr-4" style="vertical-align: middle;">info</mat-icon>
              No images added yet. Please upload at least 1 image.
            </p>
          </div>
        </ng-container>
      </div>
    </ng-container>
  </div>
</div>
